const sortingFunctions = [
	"Bubble Sort",
	"Selection Sort",
	"Insertion Sort",
	"Merge Sort",
	"Quick Sort",
	"Heap Sort",
	"Shell Sort",
	"Radix Sort",
];

export default sortingFunctions;
